import { CloseOutlined } from '@mui/icons-material'
import { Button, Grid, IconButton, Typography } from '@mui/material'
import React, { memo, useEffect, useState } from 'react'
import CustomTable from '../../customTable'
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import _ from 'lodash';
import moment from 'moment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../../../../../components/hooks/snackBar/reducers';
const YearReports = ({setOpen , data,getMonthData , setActiveStep,setMonthData , monthData}) => {
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const dispatch = useDispatch()
    // const onEditDate = (e) => {
    //     console.log(e.row)
    //     getMonthData(e.row.date)
    //     setActiveStep("1")
    // }
    const onEdit = (e) => {
        console.log(e.row);
        getMonthData(e.row.month, e.row.year);
        setActiveStep("1")
      };
      function getMonthData(month, year) {
        console.log(month, year);
        axios
          .get(`/v1/reports/sales/month/sales/${year}/${month}`)
          .then((res) => {
            console.log(res);
            setMonthData(res.data);
        setPageCount(res.data.details.length)
          })
          .catch((err) => {
            console.log(err);
            dispatch(
              setSnackbar(true, "error", err.response.data.error)
            );
          });
      }
    const columns = [
        {
            field : 'sno',
            headerName : 'S.no',
            minWidth : 70,
            maxWidth : 100,
            headerAlign : 'center',
            align : 'center',
            sortable: false
          },
          {
            field: "month",
            headerName: "month",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          
          {
            field: "credit",
            headerName: "No.of Sales",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "cash",
            headerName: "Amount",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
          {
            field: "view",
            headerName: "View",
            disableExport: true ,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            renderCell : (params) => {
                return(
                    <IconButton
                    size="small"
                    onClick={() => onEdit (params)}
                    >
                        <VisibilityIcon />
                    </IconButton>
                )
            }
          },
    ]
    const rows = _.map(data.details,(value,idx) =>({
        id: idx,
        sno: idx+1,
        month: value.month,
        cash: parseFloat(value.amount).toFixed(0),
        credit: value.no_of_sales,
        year: value.year,
    }))
    const props = {
        columns : columns,
        rows : rows,
        page: page,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
      }
      useEffect(()=>{
        if(data.details){
          setPageCount(data.details.length)
        }
      },[data])
  return (
    <Grid>
        <Grid sx={{display:"flex" , justifyContent:"space-between",padding:1,alignItems:"center"}}>
            <Button variant='contained' onClick={() => setOpen(false)}>Back</Button>
            <Typography variant='h6'>Year reports</Typography>
            <IconButton onClick={() => {setOpen(false);setActiveStep("0") }}>
                <CloseOutlined />
            </IconButton>
        </Grid>
        <Grid>
            <CustomTable props={props}/>
        </Grid>
    </Grid>
  )
}

export default memo(YearReports)